export const OPEN_LEAD_CAPTURE_MODAL_EVENT = "palmate:open-lead-capture-modal";
export const LEAD_CAPTURE_MODAL_ACTION = "openLeadCaptureModal";

export const LEAD_CAPTURE_MODAL_VARIANTS = Object.freeze({
  BOOK_DEMO: "bookDemo",
  GET_AN_OFFER: "getAnOffer",
});

export function getLeadCaptureRequestType(variant) {
  if (variant === LEAD_CAPTURE_MODAL_VARIANTS.GET_AN_OFFER) {
    return "get_offer";
  }
  return "book_demo";
}

export function openLeadCaptureModal(detail = {}) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(OPEN_LEAD_CAPTURE_MODAL_EVENT, {
      detail: detail && typeof detail === "object" ? detail : {},
    })
  );
}

export function createLeadCaptureModalAction(detail = {}) {
  return {
    action: LEAD_CAPTURE_MODAL_ACTION,
    actionArgs: [detail],
  };
}
